import { render } from "./Album.vue?vue&type=template&id=aa4ea086&scoped=true"
import script from "./Album.vue?vue&type=script&lang=js"
export * from "./Album.vue?vue&type=script&lang=js"

import "./Album.vue?vue&type=style&index=0&id=aa4ea086&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa4ea086"]])

export default __exports__